import { getApiBaseUrl } from '../../utils/api-base-url';

export const signSubmission = async (
  urlSlug: string,
  publicId: string,
  responses: Record<string, unknown>,
  userType: string,
): Promise<void> => {
  await fetch(`${getApiBaseUrl()}/submissions/${urlSlug}/${publicId}/signature?userType=${userType}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ responses }),
    credentials: 'include',
  });
};
